export { BazaarvoiceInlineRating } from './BazaarvoiceInlineRating'
export type { BazaarvoiceInlineRatingProps } from './types'
